import { useDispatch, useSelector } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from "react";
import { setBacklink } from "../redux/backlinkSlice";
import Error from "./Error";
import Loader from "./Loader";

const checkToken = (token) => {
    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decodedToken.exp > currentTime;
    } catch (error) {
        return false
    }
}

const ProtectedRoute = ({ children, requiredLevel }) => {
    const [isPermitAlert, setIsPermitAlert] = useState(true);
    const { isLogged, level, isCheckingAuth } = useSelector(state => state.user);
    const token = localStorage.getItem('ticino-wild-token');

    const [isDelayDone, setIsDelayDone] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setIsDelayDone(true)
        }, 500)
    }, [])

    // Prima di reindirizzare al login, salvo la destinazione originale come backlink:
    // LoginForm E RegisterForm la consumano dopo l'autenticazione (destination = backlink || "/"),
    // quindi chi apre un link protetto da sloggato (es. link condiviso a /activity-details)
    // ci atterra dopo login o registrazione, invece di finire sulla home.
    // Dispatch in useEffect (mai durante il render); solo per i redirect al login,
    // NON per il caso "permessi insufficienti" (lì l'utente è loggato e va a /my-profile).
    const dispatch = useDispatch();
    const location = useLocation();
    const needsLogin = !isCheckingAuth && (!token || !checkToken(token) || !isLogged);
    useEffect(() => {
        if (needsLogin) {
            dispatch(setBacklink(location.pathname + location.search));
        }
    }, [needsLogin, location.pathname, location.search, dispatch])

    if(isCheckingAuth) {
        return (
            <div className="w-full flex justify-center items-center min-h-[400px]">
                <Loader />
            </div>
        )
    }

    // Controllo 1: Token mancante o scaduto
    if (!token || !checkToken(token)) {
        return <Navigate to="/register-login?section=Login" />
    }

    // Controllo 2: Utente non loggato in Redux (refresh fallito)
    if (!isLogged) {
        return <Navigate to="/register-login?section=Login" />
    }

    // Controllo 3: Permessi insufficienti
    if (level < requiredLevel) {
        setTimeout(() => {
            setIsPermitAlert(false)
        }, 3000);

        return (
            <div className="w-full flex justify-center">
                {!isPermitAlert && <Navigate to="/my-profile" />}
                {isPermitAlert && isDelayDone && <Error text="Permessi insufficienti per accedere alla pagina" />}
            </div>
        )
    }

    return (
        <>
            <Outlet />
            {children}
        </>
    )
}

export default ProtectedRoute;